export const currentDate = () => {
    return(
    new Date().toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }
    )
   )
}

